import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import GameItem from "./GameItem.jsx";

let Flickity;
try {
    Flickity = require('flickity');
} catch (error) {
    Flickity = null;
}


export default function ThemesComponent(props) {
    const {
        session,
        games,
        brands,
        tags,
        categories,
        isDesktop,
        themes,
        config,
        sendThemeFn,
        sendUrlParameter,
        activeTheme
    } = props;

    const flickityRef = useRef(null);
    const flickityInstance = useRef(null);
    const hasMounted = useRef(false);
    const themeTabRefs = useRef([]);
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

    const addFlickity = useCallback(() => {
        const attractionValue = !isDesktop ? 1 : 0.025;
       const frictionValue = !isDesktop ?  1 : 0.28;

        if (flickityRef.current) {
            const flickityOptions = {
                cellAlign: "center",
                prevNextButtons: true,
                wrapAround: true,
                groupCells: 1,
                selectedAttraction: attractionValue,
                friction: frictionValue,
                dragThreshold: 60,
                on: {
                    ready: function () {
                        const dotsContainer = flickityRef.current?.querySelector(".flickity-page-dots");
                        if (dotsContainer) {
                            const lineLeft = document.createElement("li");
                            lineLeft.className = "line left";
                            dotsContainer.insertBefore(lineLeft, dotsContainer.firstChild);

                            const lineRight = document.createElement("li");
                            lineRight.className = "line right";
                            dotsContainer.appendChild(lineRight);
                        }
                    }
                }
            };

            flickityInstance.current = new Flickity(flickityRef.current, flickityOptions);
            flickityInstance.current.on('change', (index) => {
                setCurrentSlideIndex(index);
            });
        }
    }, []);

    useEffect(() => {
        addFlickity();
        return () => {
            if (flickityInstance.current) {
                flickityInstance.current.off('change');
                flickityInstance.current.destroy();
            }
        };
    }, [addFlickity]);

    useEffect(() => {
        if (!hasMounted.current) {
            hasMounted.current = true;
            return;
        }

        const activeTab = themeTabRefs.current[currentSlideIndex];
        if (activeTab) {
            activeTab.focus();
        }
    }, [currentSlideIndex]);

    const cacheGames = useCallback((filterGames) => {
        if (!filterGames?.length) return [];

        const randomNumbers = casinoModule.utils.generateTodayRandomNumber(filterGames.length);

        return filterGames
            .map((game, index) => ({
                ...game,
                RandomNumber: randomNumbers[index]
            }))
            .sort((a, b) => a.RandomNumber - b.RandomNumber);
    }, []);

    const filterThemeGames = useCallback((theme) => {
        if (!theme?.tag || !games?.length) return [];

        const tagId = Object.keys(tags).find(key => tags[key] === theme.tag);
        const tagIdInt = parseInt(tagId);

        const themeGames = games.filter(game => game.t?.hasOwnProperty(tagIdInt));
        return cacheGames(themeGames);
    }, [games, tags, cacheGames]);

    const renderGameIcons = useCallback((game, index) => {
        if (isDesktop && index >= 5) return null;

        return (
            <GameItem
                key={index}
                session={session}
                game={game}
                brands={brands}
                categories={categories}
                goLazyImage={true}
                showJackpot={true}
                isDesktop={isDesktop}
                restApiUrl={config?.restApiUrl}
                apiKey={config?.apiKey}
                icon={true}
                textColor="white"
            />
        );
    }, [session, brands, categories, isDesktop, config]);

    const renderThemes = useCallback((theme, index) => {
        const filteredThemeGames = filterThemeGames(theme);

        return (
            <div className={`item ${theme.code}`} key={index}>
                <h3>{theme.name}</h3>
                <p className="description">{theme.description}</p>
                <div
                    className="games-container icon"
                    onWheel={!isDesktop ? (e) => e.stopPropagation() : undefined}
                    onTouchMove={!isDesktop ? (e) => e.stopPropagation() : undefined}
                >
                    {filteredThemeGames?.map((game, index) => renderGameIcons(game, index))}
                </div>
                <button
                    onClick={() => sendThemeFn(theme.code)}
                    className="show-all"
                >
                    Prikaži sve
                </button>
                <div className="png-image" />
            </div>
        );
    }, [filterThemeGames, renderGameIcons, sendThemeFn, isDesktop]);

    const filteredThemes = useMemo(() =>
        activeTheme ? themes?.filter(theme => theme.code !== activeTheme.code) : themes,
        [themes, activeTheme]
    );

    const renderThemeTabs = useCallback((tab, index) => {
        let active = "";
        if (tab.code == filteredThemes[currentSlideIndex].code) {
            active = "active";
        }

        return (
            <button
                key={index}
                className={`theme-tab ${active}`}
                ref={(tab) => themeTabRefs.current[index] = tab}
                onClick={() => flickityInstance.current.select(index)}
            >
                {tab.name}
            </button>
        )
    }, [currentSlideIndex]);

    return (
        <div className="themes-component">
            <div className="component-header">
                <h2>Popularne Teme</h2>
                <button onClick={() => sendUrlParameter("teme")} className="show-all-themes">Prikaži sve
                </button>
            </div>

            <div className="theme-tabs">
                {filteredThemes?.map((tab, index) => renderThemeTabs(tab, index))}
            </div>

            <div className="test" ref={flickityRef}>
                {filteredThemes?.map((theme, index) => renderThemes(theme, index))}
            </div>
        </div>
    );
}
